import {selPropGen} from 'module/Properties/selector/selPropGen'
import {PropID} from 'module/Properties/enum/PropID'
import {propDefaultFalse, propDefaultTrue} from 'module/Properties/util/PropertiesUtil'

export const KokeyUserConfigDict = {
	enabled: {
		label: 'KoKey-Konfiguration',
		type: 'boolean',
		defaultValue: true,
		defaultOverrideSelector: selPropGen(PropID.koKeyDefault, propDefaultTrue),
		visibleSelector: selPropGen(PropID.koKeyVis, propDefaultFalse),
	},
} as const